module.exports = __webpack_public_path__ + "img/media-shop01.1d24b12a.jpg";